import React from 'react';

import PhotoCarousel from './PhotoCarousel';
import FeaturedPress from './FeaturedPress';

const CommunitySpotlight = () => {
  return (
    <>
      {/* Moments / carousel section */}
      <section className="sg-section">
        <div className="container">
          <div className="sg-section-header">
            <div className="sg-heading-group">
              <span className="sg-eyebrow">
                Inside Spur
              </span>

              <h2 className="sg-section-title">
                Moments That Move AgTech Forward
              </h2>
            </div>

            <p className="sg-section-description">
              Explore the conversations, demonstrations, and connections
              bringing farmers, founders, researchers, students, and
              industry leaders together.
            </p>
          </div>

          <PhotoCarousel />
        </div>
      </section>

      {/* Media section */}
      <section className="sp-section home-media-section">
        <div className="container sp-container">
          <div className="sp-section-header">
            <div>
              <span className="sp-eyebrow">
                Media Coverage
              </span>

              <h2 className="sp-section-title">
                Spur in the News
              </h2>
            </div>

            <p className="sp-section-description">
              See how regional media are covering Spur’s work to advance
              agricultural innovation and strengthen Nebraska’s AgTech
              ecosystem.
            </p>
          </div>

          <FeaturedPress />
        </div>
      </section>
    </>
  );
};

export default CommunitySpotlight;